import React, { Fragment } from "react";
import "./Create.css";
import Header from "../Components/Header/Header";
import Create from "../Components/Create/Create";

const CreatePage = () => {
  return (
    <Fragment>
      <Header />
      <Create />
    </Fragment>
  );
};

export default CreatePage;
